import { VARIABLE_DATA_TYPE_OPTIONS, type VariableDataTypeOption } from "@/constants/rule-variables";

const EXCLUDED_COLLECTION_DATA_TYPES = new Set(["boolean", "decimal", "datetime"]);

export const COLLECTION_DATA_TYPE_OPTIONS: VariableDataTypeOption[] = VARIABLE_DATA_TYPE_OPTIONS.filter(
	(opt) => !EXCLUDED_COLLECTION_DATA_TYPES.has(opt.value),
);
